(function () {
  'use strict';

  if (window.MaisonSearch) return;

  var focusableSelector = [
    'a[href]:not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function init(dialog) {
    if (!dialog || dialog.dataset.maisonInitialized === 'true') return;
    dialog.dataset.maisonInitialized = 'true';

    var panel = dialog.querySelector('[data-maison-search-panel]');
    var form = dialog.querySelector('[data-maison-search-form]');
    var input = dialog.querySelector('[data-maison-search-input]');
    var empty = dialog.querySelector('[data-maison-search-empty]');
    var results = dialog.querySelector('[data-maison-search-results]');
    var closeButtons = dialog.querySelectorAll('[data-maison-search-close]');
    var activeTrigger = null;
    var request = null;
    var timer = null;
    var inertSiblings = [];
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function triggers() {
      return Array.prototype.slice.call(document.querySelectorAll('.js-search-destop'));
    }

    function syncTriggers(open) {
      triggers().forEach(function (trigger) {
        trigger.setAttribute('aria-controls', dialog.id);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function visibleFocusable() {
      return Array.prototype.filter.call(panel.querySelectorAll(focusableSelector), function (element) {
        return element.offsetParent !== null && element.getAttribute('aria-hidden') !== 'true';
      });
    }

    function disableBackground() {
      inertSiblings = [];
      Array.prototype.forEach.call(dialog.parentElement.children, function (sibling) {
        if (sibling === dialog || sibling.tagName === 'SCRIPT') return;
        inertSiblings.push({
          element: sibling,
          inert: sibling.inert,
          ariaHidden: sibling.getAttribute('aria-hidden')
        });
        sibling.inert = true;
        sibling.setAttribute('aria-hidden', 'true');
      });
    }

    function restoreBackground() {
      inertSiblings.forEach(function (record) {
        record.element.inert = record.inert;
        if (record.ariaHidden === null) record.element.removeAttribute('aria-hidden');
        else record.element.setAttribute('aria-hidden', record.ariaHidden);
      });
      inertSiblings = [];
    }

    function resetResults() {
      if (request) request.abort();
      request = null;
      window.clearTimeout(timer);
      results.replaceChildren();
      results.hidden = true;
      results.setAttribute('aria-busy', 'false');
      empty.hidden = false;
    }

    function open(trigger) {
      if (!dialog.hidden) return;
      activeTrigger = trigger;
      dialog.hidden = false;
      document.body.classList.add('maison-search-is-open');
      disableBackground();
      syncTriggers(true);
      window.requestAnimationFrame(function () {
        dialog.classList.add('is-open');
        input.focus();
        input.select();
        if (input.value.trim().length >= 2) queueSearch();
      });
    }

    function finishClose() {
      dialog.hidden = true;
      restoreBackground();
      if (activeTrigger && document.contains(activeTrigger)) activeTrigger.focus();
      activeTrigger = null;
    }

    function close() {
      if (dialog.hidden) return;
      if (request) request.abort();
      window.clearTimeout(timer);
      dialog.classList.remove('is-open');
      document.body.classList.remove('maison-search-is-open');
      syncTriggers(false);
      if (reducedMotion.matches) finishClose();
      else window.setTimeout(finishClose, 180);
    }

    function showError() {
      results.replaceChildren();
      var message = document.createElement('p');
      message.className = 'maison-search-dialog__message';
      message.textContent = dialog.dataset.errorMessage;
      results.appendChild(message);
      results.hidden = false;
      empty.hidden = true;
    }

    function performSearch() {
      var query = input.value.trim();
      if (query.length < 2) {
        resetResults();
        return;
      }

      if (request) request.abort();
      request = new AbortController();
      var url = new URL(dialog.dataset.predictiveUrl, window.location.origin);
      url.searchParams.set('q', query);
      results.hidden = false;
      empty.hidden = true;
      results.setAttribute('aria-busy', 'true');
      results.replaceChildren();
      var loading = document.createElement('p');
      loading.className = 'maison-search-dialog__message';
      loading.textContent = dialog.dataset.loadingMessage;
      results.appendChild(loading);

      fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: request.signal
      }).then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.text();
      }).then(function (html) {
        results.innerHTML = html;
      }).catch(function (error) {
        if (error.name !== 'AbortError') showError();
      }).finally(function () {
        results.setAttribute('aria-busy', 'false');
      });
    }

    function queueSearch() {
      window.clearTimeout(timer);
      timer = window.setTimeout(performSearch, 260);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.js-search-destop');
      if (!trigger) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      open(trigger);
    }, true);

    closeButtons.forEach(function (button) {
      button.addEventListener('click', close);
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var elements = visibleFocusable();
      if (!elements.length) return;
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    input.addEventListener('input', function () {
      input.setCustomValidity('');
      if (input.value.trim().length < 2) resetResults();
      else queueSearch();
    });

    form.addEventListener('submit', function (event) {
      if (input.value.trim().length >= 2) return;
      event.preventDefault();
      input.setCustomValidity(dialog.dataset.minimumMessage);
      input.reportValidity();
      input.focus();
    });

    syncTriggers(false);
    resetResults();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-maison-search-dialog]').forEach(init);
  }

  window.MaisonSearch = { init: initAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
